import { patientService } from "@finpay-development/shared-platform/lib/esm/patient/services/patient-service";
import { PeStatusPatchBody } from "./board-columns";

export interface UpdateIocWorkflowStatusResult {
  ok: boolean;
  errorMessage: string | null;
}

/**
 * Persist board column move via PE status PATCH only.
 * Body must be the full hardcoded shape (ids + names).
 */
export async function updateIocWorkflowStatus(args: {
  patientId: number;
  encounterId: number;
  workFlow: PeStatusPatchBody;
}): Promise<UpdateIocWorkflowStatusResult> {
  const { patientId, encounterId, workFlow } = args;
  const response = await patientService.saveStatus({
    workFlow,
    encounterId,
    patientId,
  });

  if (response.hasErrors) {
    return {
      ok: false,
      errorMessage: response.errorMessage || "Failed to update workflow status",
    };
  }

  return { ok: true, errorMessage: null };
}
